<template>
  <div class="flex flex-col justify-between">
    <ProductModal
      v-if="addProductPopup"
      :product="selectedProduct"
      :userId="userId"
      :orgId="orgId"
    />
    <AddProductType
      v-if="addProductTypePopup"
      :addProductTypeActive="addProductTypeActive"
      :userId="userId"
      :orgId="orgId"
    />

    <AppDetailsPallete
      appName="market"
      class="common__box shadow-none form__container w-full h-[30vw] flex flex-col gap-y-2 rounded-none rounded-tl-lg rounded-tr-lg border-bottom"
    />
    <CKEditorModal v-if="addRedemptionInstructionsPopup" />

    <OrgProductCouponListModal v-if="orgProductCouponsList" />

    <section
      class="common__box right__container mt-4 md:mt-0 py-4 w-full rounded-none rounded-bl-lg rounded-br-lg"
    >
      <section id="add-product" class="border-bottom-dashed pb-2">
        <div class="border-bottom w-full pb-2">
          <span class="text-2xl text-black font-bold">Configuration</span>
        </div>

        <div class="flex flex-col my-4 gap-y-6">
          <div class="flex flex-col md:flex-row gap-6">
          <!-- Product Type -->
            <div class="flex flex-col md:w-1/4 gap-y-2">
              <label for="productType" class="text-lg text-black font-bold"
                >Product Type</label
              >
              <vs-select
                id="productType"
                class="w-full border-gray rounded-lg"
                placeholder="Select Product Type"
                v-model="productType"
              >
                <option
                  v-for="_productType in orgProductTypes"
                  :key="_productType.key"
                  @click="setProductType(_productType.key)"
                  class="cursor-pointer p-1 bg-gray"
                >
                  {{ _productType.label || "" }}
                </option>
              </vs-select>
            </div>

            <!-- Product Name -->
            <div class="flex flex-col md:w-1/4 gap-y-2">
              <label for="productType" class="text-lg text-black font-bold"
                >Product Name</label
              >
              <input
                type="text"
                id="product-name"
                class="rounded-lg p-3 border-2 border-gray w-full"
                placeholder="Enter Product Name"
                v-model="productName"
              />
            </div>

            <!-- Inventory Count -->
            <div class="flex flex-col md:w-1/4 gap-y-2">
              <label for="productType" class="text-lg text-black font-bold"
                >Inventory Count</label
              >
              <input
                type="number"
                id="product-stock"
                class="border-2 border-gray rounded-lg p-2 h-full"
                placeholder="Enter Product Price"
                v-model="productInStock"
                min="0"
                @input="productInStock = Math.max(0, productInStock)"
              />
            </div>

            <!-- Cost Per Unit -->
            <div class="flex flex-col md:w-1/4 gap-y-2">
              <label for="productType" class="text-lg text-black font-bold"
                >Costs per Unit</label
              >
              <div class="flex gap-x-2 lg:gap-x-6">
                <input
                  type="number"
                  id="product-price"
                  v-model="productPrice"
                  class="border-2 border-gray rounded-lg p-2 w-3/5"
                  placeholder="Enter Product Price"
                  min="0"
                  @input="productPrice = Math.max(0, productPrice)"
                />
                <vs-select
                  id="priceType"
                  name="product-price"
                  class="w-2/5 flex flex-col justify-center items-center border-gray rounded-lg"
                  placeholder=""
                  v-model="selectedPriceType"
                >
                  <option
                    v-for="price in orgPriceTypes"
                    :key="price.key"
                    @click="setSelectedPriceType(price.key)"
                    class="cursor-pointer p-1 bg-gray"
                  >
                    {{ price.label || "" }}
                  </option>
                </vs-select>
              </div>
            </div>
          </div>
          <div class="flex flex-col lg:flex-row gap-3 lg:gap-6">
            <!-- Product Description -->
            <div class="flex flex-col lg:w-1/2 gap-y-2">
              <label for="productType" class="text-lg text-black font-bold"
                >Product Description</label
              >
              <vs-textarea
                id="product-description"
                class="border-2 border-gray -mb-1 rounded-lg w-full pb-4"
                placeholder="Enter Product Description"
                rows="4"
                v-model="productBrief"
              ></vs-textarea>
            </div>

            <!-- Product Gallery -->
            <div class="flex flex-col lg:w-1/2 gap-y-2">
              <label for="productType" class="text-lg text-black font-bold"
                >Product Gallery
                <span class="text-lg font-light"
                  >(Up to 4 pictures)</span
                ></label
              >
              <div class="flex flex-wrap gap-x-3 lg:gap-x-1 gap-y-1">
                <div v-for="(image, index) in [0, 1, 2, 3]" :key="index">
                  <label
                    v-if="files[index] === undefined"
                    for="dropzone-file"
                    class="flex flex-col items-center justify-center w-full h-40 border-2 border-gray rounded-lg cursor-pointer bg-gray-50"
                  >
                    <div class="flex flex-col items-center justify-center p-3">
                      <svg
                        width="100"
                        height="100"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.9508 6.125C16.6003 6.125 15.3559 6.85719 14.7 8.03777L13.5752 10.0625H10.2812C7.50256 10.0625 5.25 12.3151 5.25 15.0938V29.9688C5.25 32.7474 7.50256 35 10.2812 35H20.1218C19.8312 34.3032 19.608 33.5713 19.4602 32.8125H10.2812C8.71069 32.8125 7.4375 31.5393 7.4375 29.9688V15.0938C7.4375 13.5232 8.71069 12.25 10.2812 12.25H14.8623L16.6122 9.10009C16.8823 8.61399 17.3947 8.3125 17.9508 8.3125H24.0492C24.6053 8.3125 25.1177 8.61399 25.3878 9.10009L27.1377 12.25H31.7188C33.2893 12.25 34.5625 13.5232 34.5625 15.0938V19.9499C35.3345 20.2348 36.0672 20.601 36.75 21.0381V15.0938C36.75 12.3151 34.4974 10.0625 31.7188 10.0625H28.4248L27.3 8.03777C26.6441 6.85719 25.3997 6.125 24.0492 6.125H17.9508Z"
                          fill="#667085"
                        />
                        <path
                          d="M21 14.875C24.0868 14.875 26.7069 16.873 27.6377 19.6463C26.9247 19.8398 26.2395 20.101 25.5895 20.4225C24.9735 18.4746 23.1516 17.0625 21 17.0625C18.3421 17.0625 16.1875 19.2171 16.1875 21.875C16.1875 24.1863 17.8169 26.1171 19.9897 26.5813C19.7326 27.2571 19.5381 27.9639 19.4132 28.6944C16.3116 27.9755 14 25.1952 14 21.875C14 18.009 17.134 14.875 21 14.875Z"
                          fill="#667085"
                        />
                        <path
                          d="M40.25 30.625C40.25 35.9407 35.9407 40.25 30.625 40.25C25.3093 40.25 21 35.9407 21 30.625C21 25.3093 25.3093 21 30.625 21C35.9407 21 40.25 25.3093 40.25 30.625ZM31.5 25.375C31.5 24.8917 31.1083 24.5 30.625 24.5C30.1417 24.5 29.75 24.8917 29.75 25.375V29.75H25.375C24.8917 29.75 24.5 30.1417 24.5 30.625C24.5 31.1083 24.8917 31.5 25.375 31.5H29.75V35.875C29.75 36.3583 30.1417 36.75 30.625 36.75C31.1083 36.75 31.5 36.3583 31.5 35.875V31.5H35.875C36.3583 31.5 36.75 31.1083 36.75 30.625C36.75 30.1417 36.3583 29.75 35.875 29.75H31.5V25.375Z"
                          fill="#667085"
                        />

                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        ></path>
                      </svg>
                    </div>
                    <input
                      type="file"
                      id="dropzone-file"
                      class="hidden"
                      multiple
                      accept="image/*"
                      @change="previewFiles"
                    />
                  </label>
                  <div class="relative" v-else>
                    <img
                    v-if="fileViews[index]"
                      class="rounded-lg preview_images object-cover"
                      :src="fileViews[index]"
                      alt="Product Image"
                    />

                    <label
                      v-else
                      for="dropzone-file"
                      class="flex flex-col items-center justify-center w-full h-40 border-2 border-gray rounded-lg cursor-pointer bg-gray-50"
                    >
                      <div
                        class="flex flex-col items-center justify-center p-3"
                      >
                        <svg
                          width="100"
                          height="100"
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.9508 6.125C16.6003 6.125 15.3559 6.85719 14.7 8.03777L13.5752 10.0625H10.2812C7.50256 10.0625 5.25 12.3151 5.25 15.0938V29.9688C5.25 32.7474 7.50256 35 10.2812 35H20.1218C19.8312 34.3032 19.608 33.5713 19.4602 32.8125H10.2812C8.71069 32.8125 7.4375 31.5393 7.4375 29.9688V15.0938C7.4375 13.5232 8.71069 12.25 10.2812 12.25H14.8623L16.6122 9.10009C16.8823 8.61399 17.3947 8.3125 17.9508 8.3125H24.0492C24.6053 8.3125 25.1177 8.61399 25.3878 9.10009L27.1377 12.25H31.7188C33.2893 12.25 34.5625 13.5232 34.5625 15.0938V19.9499C35.3345 20.2348 36.0672 20.601 36.75 21.0381V15.0938C36.75 12.3151 34.4974 10.0625 31.7188 10.0625H28.4248L27.3 8.03777C26.6441 6.85719 25.3997 6.125 24.0492 6.125H17.9508Z"
                            fill="#667085"
                          />
                          <path
                            d="M21 14.875C24.0868 14.875 26.7069 16.873 27.6377 19.6463C26.9247 19.8398 26.2395 20.101 25.5895 20.4225C24.9735 18.4746 23.1516 17.0625 21 17.0625C18.3421 17.0625 16.1875 19.2171 16.1875 21.875C16.1875 24.1863 17.8169 26.1171 19.9897 26.5813C19.7326 27.2571 19.5381 27.9639 19.4132 28.6944C16.3116 27.9755 14 25.1952 14 21.875C14 18.009 17.134 14.875 21 14.875Z"
                            fill="#667085"
                          />
                          <path
                            d="M40.25 30.625C40.25 35.9407 35.9407 40.25 30.625 40.25C25.3093 40.25 21 35.9407 21 30.625C21 25.3093 25.3093 21 30.625 21C35.9407 21 40.25 25.3093 40.25 30.625ZM31.5 25.375C31.5 24.8917 31.1083 24.5 30.625 24.5C30.1417 24.5 29.75 24.8917 29.75 25.375V29.75H25.375C24.8917 29.75 24.5 30.1417 24.5 30.625C24.5 31.1083 24.8917 31.5 25.375 31.5H29.75V35.875C29.75 36.3583 30.1417 36.75 30.625 36.75C31.1083 36.75 31.5 36.3583 31.5 35.875V31.5H35.875C36.3583 31.5 36.75 31.1083 36.75 30.625C36.75 30.1417 36.3583 29.75 35.875 29.75H31.5V25.375Z"
                            fill="#667085"
                          />
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                          ></path>
                        </svg>
                      </div>
                      <input
                        type="file"
                        id="dropzone-file"
                        class="hidden"
                        multiple
                        accept="image/*"
                        @change="previewFiles"
                      />
                    </label>

                    <div
                    v-if="fileViews[index]"
                      class="absolute top-0 right-0"
                      @click="removeImageFiles(index)"
                    >
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 0H15C18.3137 0 21 2.68629 21 6V20H6C2.68629 20 0 17.3137 0 14V0Z"
                          fill="#FD853A"
                        />
                        <path
                          d="M15 6L7 14"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7 6L15 14"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex md:flex-row flex-col justify-between md:items-center">
            <div class="flex flex-wrap w-full md:w-3/4 gap-x-4">
              <mint-modal :orgId="orgId" :isMarketAdmin="true" />
              <div
                class="flex justify-between items-center gap-x-1"
                @click="shipping = !shipping"
              >
                <input
                  class="border-gray"
                  type="checkbox"
                  id="shipping"
                  name="shipping"
                  :checked="shipping"
                />
                <p class="text-sm coupons-text">Shipping</p>
              </div>
              <div
                class="flex justify-between items-center gap-x-1"
                @click="
                  $store.commit(
                    'modals/OPEN_ORG_PRODUCT_COUPON_LIST_MODAL',
                    true
                  )
                "
              >
                <input
                  class="border-gray"
                  type="checkbox"
                  :checked="orgProductCouponCodes.length > 0"
                  @click="preventToggle"
                />
                <p class="text-sm coupons-text">Redemption Codes</p>
              </div>
              <div
                class="flex justify-between items-center gap-x-1"
                @click="
                  $store.commit(
                    'modals/OPEN_REDEMPTION_INSTRUCTIONS_POPUP',
                    true
                  )
                "
              >
                <input
                  class="border-gray"
                  type="checkbox"
                  :checked="orgProductRedemptionInstructions.length > 0"
                  @click="preventToggle"
                />
                <p class="text-sm coupons-text hover:cursor-pointer">
                  Instructions
                </p>
              </div>
            </div>
            <vs-button
              class="mt-1 rounded-lg"
              size="normal"
              @click="addProduct()"
              >Add Product</vs-button
            >
          </div>
        </div>
      </section>
      <section class="px-2 py-6">
        <vs-row
          id="product-overview"
          class="flex flex-wrap gap-2 lg:gap-3 overflow-y-scroll scrollbarWidth justify-start"
        >
          <vs-col
            v-for="(product, key) in productDetails"
            class="product__card p-3 rounded-md flex flex-col relative"
            :key="key"
          >
            <div
              class="w-full overflow-hidden relative product__card__img h-48"
            >
              <img
                class="w-full h-full object-cover rounded-lg"
                :src="product.product_images[0]"
                :alt="product.product_name"
              />
              <vs-icon
                class="flex items-center justify-center bg-black top-0 right-0 absolute cursor-pointer rounded-bl-lg rounded-tr-lg"
                icon="icon-edit"
                size="1.75em"
                icon-pack="feather"
                color="#FFF"
                @click="setSelectedProduct(product)"
              />
            </div>
            <h4 class="font-semibold mt-4 uppercase truncate">
              {{ product.product_name }}
            </h4>
            <h5 class="mt-4 mb-8">
              {{
                product.product_brief.slice(0, 50) +
                (product.product_brief.length > 50 ? "..." : "")
              }}
            </h5>
            <div class="flex items-center gap-x-1 absolute bottom-4">
              <p class="text-xl">
                {{
                  orgPriceTypes.filter(
                    (price) => price.key == product.product_price_type
                  )[0]
                    ? orgPriceTypes.filter(
                        (price) => price.key == product.product_price_type
                      )[0].label || ""
                    : ""
                }}
              </p>
              <h4 class="font-semibold">
                {{
                  product.product_price.slice(0, 5) +
                  (product.product_price.length > 5 ? "..." : "")
                }}
              </h4>
            </div>
          </vs-col>
        </vs-row>
      </section>
    </section>
  </div>
</template>

<script>
import ProductModal from "../../../../modals/ProductModal.vue";
import constants from "@/constants";
import AddProductType from "../../../../modals/AddProductType.vue";
import CKEditorModal from "../../../../modals/CKEditorModal.vue";
import OrgProductCouponListModal from "../../../../modals/OrgProductCouponListModal.vue";
import MintModal from "../../../../modals/MintModal.vue";
import AppDetailsPallete from "./app-details-pallete/AppDetailsPallete.vue";

export default {
  components: {
    ProductModal,
    AddProductType,
    CKEditorModal,
    OrgProductCouponListModal,
    AppDetailsPallete,
    MintModal,
  },
  data() {
    return {
      addProductTypeActive: false,
      active: false,
      showPreview: false,
      productType: "Merchendise",
      productTypeIndex: 0,
      productName: "",
      productBrief: "",
      productInStock: 0,
      productPrice: 0,
      files: [],
      fileViews: [],
      priceType: [],
      selectedPriceType: "",
      selectedPriceTypeIndex: 1,
      constants,
      productDetails: [],
      selectedProduct: {},
      productTypes: [],
      userOrgData: {
        firstName: "",
        lastName: "",
        profilePictureUrl: "",
      },
      userId: "",
      orgId: "",
      shipping: false,
      isMintable: false,
      v: false,
    };
  },
  computed: {
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    addProductTypePopup() {
      return this.$store.state.modals.addProductTypePopup;
    },
    addProductPopup() {
      return this.$store.state.modals.addProductPopup;
    },
    addRedemptionInstructionsPopup() {
      return this.$store.state.modals.addRedemptionInstructionsPopup;
    },
    orgProductTypes() {
      return this.$store.state.market.orgProductTypes;
    },
    orgPriceTypes() {
      return this.$store.state.market.orgPriceTypes;
    },
    orgProductCouponsList() {
      return this.$store.state.modals.openProductCouponsListModal;
    },
    orgProductCouponCodes() {
      return this.$store.state.market.orgProductCouponCodes;
    },
    orgProductRedemptionInstructions() {
      return this.$store.state.market.orgProductRedemptionInstructions;
    },
    orgProductMintableContractDetails() {
      return this.$store.state.market.orgProductMintableContractDetails;
    },
  },
  mounted() {
    // console.log(this.orgData);
    this.orgId = this.orgData._id;
    this.fetchDetailsOnLoad();
  },
  watch: {
    orgData: {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal);
        // console.log(Object.keys(oldVal).length);
        if (newVal !== oldVal && Object.keys(oldVal).length > 0) {
          this.orgId = newVal._id;
          this.fetchDetailsOnLoad();
        }
      },
      deep: true,
      setImmediate: true,
    },
    userOrgData: function () {
      if (this.userOrgData.accessLevel !== "admin") {
        this.$router.push("/");
      }
    },
  },
  methods: {
    preventToggle(e) {
      e.preventDefault();
    },
    resetForm() {
      const resetContractDetails = {
        contractType: "",
        network: {
          text: "",
          value: 0,
          chainIdHex: 0x0,
          chainId: 0,
          currency: "",
        },
        contractAddress: "",
        mintFunctionABI: [],
        mintFunctionName: "",
        mintFunctionParameters: "",
        mintPriceETH: "",
      };
      this.productName = "";
      this.productBrief = "";
      this.productInStock = 0;
      this.productPrice = 0;
      this.files = [];
      this.fileViews = [];
      this.shipping = false;
      this.$store.commit("market/ORG_PRODUCT_COUPONS", []);
      this.$store.commit("market/ORG_PRODUCT_REDEMPTION_INSTRUCTIONS", "");
      this.$store.commit(
        "market/ORG_PRODUCT_MINTABLE_CONTRACT_DETAILS",
        resetContractDetails
      );
    },
    capitalizeFirstLetter(string) {
      return string
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    },
    getBase64Image(imageData) {
      return `data:image/jpeg;base64,${imageData}`;
    },
    setSelectedPriceType(_value) {
      this.selectedPriceType = this.orgPriceTypes.filter(
        (price) => price.key === _value
      )[0].label;
      this.selectedPriceTypeIndex = _value;
    },
    setProductType(_value) {
      this.productType = this.orgProductTypes[_value].label || "";
      this.productTypeIndex = _value;
    },
    addProduct() {
      this.$vs.loading();
      const accessToken = localStorage.getItem("accessToken");
      const coupons = this.orgProductCouponCodes;
      const redemptionInstructions = this.orgProductRedemptionInstructions;
      const formData = new FormData();
      formData.append("category", this.productTypeIndex);
      formData.append("in_store", this.productInStock.toString());
      formData.append("product_name", this.productName);
      formData.append("product_price", this.productPrice.toString());
      formData.append(
        "product_price_type",
        this.selectedPriceTypeIndex.toString()
      );
      formData.append("product_brief", this.productBrief);
      formData.append("product_coupons", JSON.stringify(coupons));
      formData.append("shipping", this.shipping.toString());
      formData.append(
        "isMintable",
        (
          this.orgProductMintableContractDetails.contractAddress !== "" &&
          this.orgProductMintableContractDetails.mintFunctionABI.length > 0
        ).toString()
      );
      formData.append(
        "product_mintable_contract_details",
        JSON.stringify(this.orgProductMintableContractDetails)
      );
      formData.append(
        "product_redemption_instructions",
        redemptionInstructions
      );
      formData.append("organisationId", this.orgId);

      this.files.forEach((image) => {
        formData.append("files", image);
      });

      // console.log(this.files)

      const payload = {
        formData,
        orgId: this.orgId,
        userId: this.userId,
        accessToken,
      };

      this.$store
        .dispatch("organization/addProduct", payload)
        .then((message) => {
          this.fetchProducts();
          this.resetForm();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Adding Product",
            text: message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            // color: 'warning'
          });
        })
        .catch((error) => {
          // console.log(error);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Adding Product",
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    fetchProducts() {
      // const payload = { orgId: "644718dd5faf2900148f9052" };
      const _accessToken = localStorage.getItem("accessToken");
      const _user = JSON.parse(localStorage.getItem("user"));
      if (
        this.orgId === undefined ||
        _user._id === undefined ||
        _accessToken === undefined
      ) {
        return;
      }
      const payload = {
        orgId: this.orgId,
        userId: _user._id,
        accessToken: _accessToken,
      };
      this.$store
        .dispatch("organization/fetchProducts", payload)
        .then((res) => {
          this.productDetails = res;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setSelectedProduct(product) {
      this.selectedProduct = product;
      this.$store.commit("modals/OPEN_PRODUCT_POPUP", true);
    },

    removeImageFiles(index) {
      if (index >= 0 && index < this.files.length) {
        this.fileViews.splice(index, 1, "");
        this.files.splice(index, 1, null);
      }
    },
    previewFiles(e) {
      if (e.target.files.length + this.fileViews.length > 4) {
        alert("You can only upload 4 images");
        return;
      }
      this.showPreview = true;
      this.files = [...this.files, ...e.target.files];
      this.fileViews = [];
      this.files.forEach(async (file) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);
        reader.onload = () => {
          this.fileViews.push(reader.result);
        };
      });
    },
    fetchUserDetails() {
      const user = this.getUserDetailsFromLocalStorage();
      const accessToken = localStorage.getItem("accessToken");
      const payload = { accessToken };
      if (
        user &&
        accessToken &&
        accessToken !== "" &&
        accessToken !== null &&
        accessToken !== undefined
      ) {
        this.$store
          .dispatch("organization/fetchUserDetails", payload)
          .then((res) => {
            this.userDetails = res;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // console.log("User not logged in");
      }
    },
    fetchOrgProductAndPriceTypes() {
      const _accessToken = localStorage.getItem("accessToken");
      const payload = { orgId: this.orgId, accessToken: _accessToken };

      if (
        _accessToken &&
        _accessToken !== "" &&
        _accessToken !== null &&
        _accessToken !== undefined &&
        this.orgId !== undefined
      ) {
        this.$store
          .dispatch("organization/fetchOrgProductAndPriceTypes", payload)
          .then((res) => {
            this.$store.commit("market/ORG_PRICE_TYPES", res[0]);
            this.$store.commit("market/ORG_PRODUCT_TYPES", res[1]);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    fetchUserOrgAccessLevel() {
      const user = this.getUserDetailsFromLocalStorage();
      const accessToken = localStorage.getItem("accessToken");
      const payload = {
        userId: user._id,
        orgId: this.orgId,
        accessToken,
      };
      if (
        user &&
        user._id &&
        user._id !== "" &&
        user._id !== null &&
        user._id !== undefined &&
        this.orgId !== undefined
      ) {
        this.$store
          .dispatch("organization/fetchUserOrgAccessLevel", payload)
          .then((res) => {
            if (
              res.accessLevel !== "admin" &&
              res.accessLevel !== "super-admin"
            ) {
              this.$router.push("/user/dashboard");
            }
            this.userOrgData = res;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // console.log("User not logged in");
      }
    },
    getUserDetailsFromLocalStorage() {
      return JSON.parse(localStorage.getItem("user"));
    },
    fetchDetailsOnLoad() {
      // this.fetchUserOrgAccessLevel();
      this.fetchProducts();
      this.fetchUserDetails();
      this.fetchOrgProductAndPriceTypes();
      this.userId = JSON.parse(localStorage.getItem("user"))._id;
    },
  },
};
</script>

<!-- http://localhost:8080/organization/gala/marketplace/config/marketapp -->

<style lang="scss" scoped>
#product-overview {
  max-height: 350px;
}
.border-bottom {
  border-bottom: 1px solid rgb(238, 238, 238);
}
.border-bottom-dashed {
  border-bottom: 1px dashed #c7c7c7;
}
.pallete-height {
  min-height: 100vh;
}
.bottom-4 {
  bottom: 4px;
}
.negative-top-right-7 {
  top: -7px;
  right: -7px;
}
.border-large-rounded {
  border-radius: 50%;
}
.semi-orange-bg {
  background-color: #fd853a;
}
.border-gray {
  border: 1px solid #d2d3d3;
  // border-color: #D2D3D3;
}
.bg-gray:hover {
  background-color: #f7f7f7;
  // border-color: #D2D3D3;
}
.scrollbarWidth::-webkit-scrollbar {
  width: 7px;
}
.scrollbarWidth::-webkit-scrollbar-thumb {
  border-radius: 7px;
  -webkit-box-shadow: inset 0 0 20px rgb(193, 193, 193);
}
.background-white {
  background-color: #ffffff;
}

.preview_images {
  width: 130px !important;
  height: 130px !important;
  justify-content: center;
}

.coupons-text:hover {
  color: rgb(107, 107, 107) !important;
  cursor: pointer;
}

.common {
  &__box {
    padding: 2em;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0px 15px 55px 0px rgba(157, 163, 180, 0.16);
  }
}

.form__container {
  .font__large {
    font-size: 1.5em;
  }
  .font__normal {
    font-size: 1.25em;
  }
  .font__small {
    font-size: 1em;
  }

  h2 {
    color: #101828;
    font-weight: 600;
  }
  h3 {
    color: #798ba0;
    font-weight: 500;
  }

  .product__type {
    display: grid;
    place-content: start;
    justify-content: start;
    grid-auto-flow: column;
    gap: 1em;
    margin: 0.5em 0em;

    &__item {
      position: relative;
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      place-content: start;

      input {
        appearance: none;
        height: 15px;
        width: 15px;
        border: solid 1px #f29300;
        border-color: #f29300;
        border-radius: 50%;
        background-color: #ffffff;
        margin-right: 0.3em;
        display: grid;
        place-content: center;
        position: relative;
        cursor: pointer;
      }

      input:before {
        content: " ";
        position: absolute;
        z-index: 1;
        top: 1px;
        bottom: 1px;
        left: 1px;
        right: 1px;
        border-radius: 50%;
        border: 2px solid #ffffff;
      }

      input:checked {
        background-color: #f29300;
      }

      label {
        color: #798ba0;
        font-weight: 500;
        padding-top: 0.25em;
        cursor: pointer;
      }
    }
  }

  .product__model {
    display: grid;
    place-content: start;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin: 0.5em 0em;

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 0.5em;
    }

    select {
      color: #8e9090;
      font-weight: 500;
      padding: 1em;
      border-radius: 0.3em;
      border: solid 1px #8e9090;
      background-color: #ffffff;
      grid-column: span 1 / span 1;
      margin-bottom: 0.5em;

      option {
        color: #363939;
      }
    }

    caption {
      color: #57595a;
      font-weight: 400;
      margin: 0.3em 0em;
      padding: 0em;
    }
  }

  .product__upload {
    margin: 0.5em 0em;
    span {
      color: #98a2b3;
    }

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 1em;
    }

    .upload__box {
      border: dashed 1px #d2d3d3;
      display: grid;
      place-content: center;
      justify-content: center;
      padding: 1em 0em;
      cursor: pointer;

      input[type="file"] {
        left: 0;
        top: 0;
        opacity: 0;
        cursor: pointer;
      }

      img {
        width: 25px;
        height: 25px;
        place-self: center;
        margin-bottom: 0.8em;
      }

      label {
        color: #363939;
        font-weight: 000;
        text-align: center;
        padding: 0em;
      }

      caption {
        color: #57595a;
        font-weight: 400;
        text-align: center;
        padding: 0em;

        a {
          color: #1681ec;
          padding: 0em;
        }
      }
    }
  }

  button {
    background-color: #f2c046;
    color: #fff;
    padding: 0.8em;
    border-radius: 0.3em;
    border-style: none;
    margin-top: 2em;
    font-weight: 600;
  }
}

.right__container {
  width: 65%;
  // height: 100vh;
  .market__banner {
    background: url(../../../../assets/images/marketplace/market-header.svg)
      no-repeat;
    background-size: cover;
    border-radius: 6px;
  }

  .product__card {
    border: 2px solid #eaecf0;
    border-radius: 8px;
    max-width: 14rem;
    x &__img {
      border-radius: 8px;
    }
    h5 {
      color: #667085 !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  .right__container {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .right__container {
    .product__card {
      max-width: 10rem;
    }
  }
}
</style>
